import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    cursor: 'pointer'
  },

  menuPaper: {
    border: '1px solid #F0F0F0',
    borderRadius: '8px',
    boxShadow: '0px 20px 30px 2px rgba(0, 0, 0, 0.16)',
    minWidth: '320px',
    width: '320px',
    maxWidth: '320px',
    background: 'white',
    color: 'black'
  },

  menuList: {
    padding: '0'
  }
}))

export default useStyles
